import { EventRow } from './logger.event-row';
import { loggerConstants } from './logger.constants';
import type { IExtendedTelemetryItem } from '@microsoft/1ds-analytics-web-js';

/**
 * Shadow fabric native event for both
 *  - `@trident/certified-events/src/lib/standard-feature-events.d.ts``
 *  - `@trident/certified-events/src/lib/application-events.d.ts`
 *  in Madrid
 */
export class FabricNativeCertifiedEvent extends EventRow {
    constructor(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        properties: Record<string, any>,
    ) {
        super(loggerConstants.Event_FabricNativeCertifiedEvent, properties);
    }

    public generateLoggingEntry(): IExtendedTelemetryItem {
        return {
            name: loggerConstants.Event_FabricNativeCertifiedEvent,
            data: this.properties
        };
    }
}
